import LabelAudit from './src/main';

/* istanbul ignore next */
LabelAudit.install = function(Vue) {
  Vue.component(LabelAudit.name, LabelAudit);
};

export default LabelAudit;
